<div class="no-right-space-page">
  <div class="one-column-content">
    <h1>{{'SCENARIO_COMPARISON.ENTRY.HEADER' | anessaTranslation: trigger}}</h1>
    <div class="relative-container table-spacing">
      <anessa-table [data]="scenarios"
                    [keys]="['name']"
                    [isAdditionalActive]="true"
                    [additionalBtnLinkText]="'SCENARIO_COMPARISON.ENTRY.DUPLICATE_BTN'"
                    (onAdditional)="duplicateScenario($event)"
                    (onEdit)="onEditClick($event)"
                    (onRemove)="onRemoveClick($event)"
                    [errorItems]="invalidScenariosList"
                    [warningItems]="affectedScenariosList"
                    [loadingItems]="loadingScenariosList"
      >
      </anessa-table>
    </div>

    <div style="margin-bottom: 100px">
      <button id="scenario-entry-add_button"
              type="button"
              mat-button
              class="mat-mdc-button first-layer-button"
              (click)="onAddClick()">{{'SCENARIO_COMPARISON.ENTRY.ADD_SCENARIO' | anessaTranslation: trigger}}</button>
      <button id="scenario-entry-simulate_button"
              type="button"
              mat-button
              class="mat-mdc-button first-layer-button"
              [disabled]="scenarios.length < 1"
              (click)="onComputeClick()">{{'SCENARIO_COMPARISON.ENTRY.SIMULATE_SCENARIOS' | anessaTranslation: trigger}}</button>
    </div>

  </div>
</div>
